exports.f = require('./_wks');


//////////////////
// WEBPACK FOOTER
// /Users/eugene.tolmachev/node_modules/core-js/library/modules/_wks-ext.js
// module id = 78
// module chunks = 0